const Util = {};
// Util.userUrl = "http://192.168.1.193:8089/";
Util.userUrl = "https://end.yaolaidao.com/";//线上/
Util.imageUrl = "";
// Util.imageUrl2 = "http://192.168.1.111:8088/";
// Util.imageUrl1 = "https://cy-img.obs.cn-north-4.myhuaweicloud.com/";
Util.imageUrl1 = "https://cy-obs.obs.cn-east-3.myhuaweicloud.com/";
Util.openid = "111";
export default Util;


// WEBPACK FOOTER //
// ./src/common/js/util.js